export default __webpack_public_path__ + "static/media/hospitality9.a53c009c.jpg";